export default "__VITE_ASSET__Cu5ImPMN__"